module.exports = __webpack_public_path__ + "img/1.316175e3.png";